// local skip TTLs; replace with server if you want
const KEY = "skip_map_v1";

function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || "{}"); }
    catch { return {}; }
}
function write(map) {
    localStorage.setItem(KEY, JSON.stringify(map));
}

export function getSkipMap() {
    const map = read();
    const now = Date.now();
    // prune expired
    let dirty = false;
    for (const k of Object.keys(map)) {
        if (map[k] <= now) { delete map[k]; dirty = true; }
    }
    if (dirty) write(map);
    return map;
}

export function skipUser(userId, minutes = 30) {
    const map = getSkipMap();
    const until = Date.now() + minutes * 60 * 1000;
    map[userId] = until;
    write(map);
    return until;
}

export function isSkipped(userId) {
    const map = getSkipMap();
    return typeof map[userId] === "number" && map[userId] > Date.now();
}
